import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { resetPasswordApi } from "../api/forgotPasswordApi";

/**
 * hooks for forgot password
 */
export default function useChangePassword() {
  const [clearError, setClearError] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const navigate = useNavigate();

  const location = useLocation();

  const passwordResetToken = new URLSearchParams(location.search).get("password_reset_token");

  const [errors, setErrors] = useState({
    password: true,
    passwordConfirm: true,
  });

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (password !== passwordConfirm) return;
    const response = await resetPasswordApi(passwordResetToken || "", password);
    if (response.status === 200) {
      navigate("/login");
    }
  };

  return {
    password,
    passwordConfirm,
    disabledSubmit: errors.password || errors.passwordConfirm,
    clearError,
    setPassword,
    setPasswordConfirm,
    setErrors,
    handleSubmit,
  };
}
